var _path, _path2, _circle, _circle2, _circle3, _path3, _circle4, _path4, _circle5, _path5, _circle6, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 268,
    height: 170,
    viewBox: "0 0 268 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1437 109.095C16.7539 109.032 17.3733 109 18 109C27.9412 109 36 117.059 36 127C36 128.735 35.7546 130.413 35.2965 132H94V112C94 95.9838 81.0162 83 65 83H45C29.9644 83 17.6012 94.4426 16.1437 109.095Z",
    fill: "#E4E4E4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M201 83C184.984 83 172 95.9838 172 112V132H232.704C232.246 130.413 232 128.735 232 127C232 117.11 239.976 109.083 249.847 109.001C248.346 94.3937 236.004 83 221 83H201Z",
    fill: "#E4E4E4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 53.5,
    r: 25.5,
    fill: "#E4E4E4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 210.5,
    cy: 53.5,
    r: 25.5,
    fill: "#E4E4E4"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 133,
    cy: 37,
    r: 37,
    fill: "#007ACD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77 110C77 93.9837 89.9837 81 106 81H162C178.016 81 191 93.9837 191 110V152H77V110Z",
    fill: "#007ACD"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 184.5,
    cy: 143.5,
    r: 26.5,
    fill: "#F4B045"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185 132C183.896 132 183 132.895 183 134V143H174C172.895 143 172 143.895 172 145C172 146.105 172.895 147 174 147H183V156C183 157.105 183.896 158 185 158C186.104 158 187 157.105 187 156V147H196C197.104 147 198 146.105 198 145C198 143.895 197.104 143 196 143H187V134C187 132.895 186.104 132 185 132Z",
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 250.5,
    cy: 127.5,
    r: 17.5,
    fill: "#E4E4E4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M250.344 119.906C249.615 119.906 249.023 120.497 249.023 121.226V127.17H243.08C242.351 127.17 241.759 127.761 241.759 128.491C241.759 129.22 242.351 129.811 243.08 129.811H249.023V135.755C249.023 136.484 249.615 137.075 250.344 137.075C251.074 137.075 251.665 136.484 251.665 135.755V129.811H257.608C258.338 129.811 258.929 129.22 258.929 128.491C258.929 127.761 258.338 127.17 257.608 127.17H251.665V121.226C251.665 120.497 251.074 119.906 250.344 119.906Z",
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 127.5,
    r: 17.5,
    fill: "#E4E4E4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3442 119.906C16.6147 119.906 16.0234 120.497 16.0234 121.226V127.17H10.08C9.3506 127.17 8.75928 127.761 8.75928 128.491C8.75928 129.22 9.3506 129.811 10.08 129.811H16.0234V135.755C16.0234 136.484 16.6147 137.075 17.3442 137.075C18.0736 137.075 18.6649 136.484 18.6649 135.755V129.811H24.6083C25.3378 129.811 25.9291 129.22 25.9291 128.491C25.9291 127.761 25.3378 127.17 24.6083 127.17H18.6649V121.226C18.6649 120.497 18.0736 119.906 17.3442 119.906Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.73b0ff1c46f4a9f8a3144b5ce9f2786a.svg";
export { ForwardRef as ReactComponent };